import { useMediaQuery } from '@mui/material'
import cx from 'classnames'
import React from 'react'

const QuizProgress = ({ label, current, total, visited }) => {
  const isMobileView = useMediaQuery('(max-width: 767px)')

  const renderBar = () =>
    new Array(total).fill(null).map((_, index) => (
      <span
        key={`_pbar_${index}`}
        className={cx(
          '[ f-fl-expand f-pos-rel ] QuizProgress-bar-item QuizProgress-bar-item--compact',
          {
            'is-visited': current <= index && index < visited,
            'is-unvisited': current <= index && index >= visited,
            'is-active': current > index
          }
        )}
      />
    ))

  return (
    <div className='[ f-m-h-auto f-p-h-020:m ] QuizApp-wrap'>
      {isMobileView ? (
        <div className='[ f-overflow f-d-flr ] QuizProgress-bar QuizProgress-bar--compact'>
          {renderBar()}
        </div>
      ) : (
        <div className='[ f-p-t-020 ]'>
          <span className='[ f-t-body QuizProgress-bar__label QuizProgress-bar__label--compact ]'>
            {label || 'Frage'}: {current > total ? total : current}/{total}
          </span>
          <div className='[ f-m-t-010 f-overflow f-d-flr ]'>{renderBar()}</div>
        </div>
      )}
    </div>
  )
}

export default QuizProgress
